import { render, staticRenderFns } from "./visitorRecord.vue?vue&type=template&id=3d85c29a&"
import script from "./visitorRecord.vue?vue&type=script&lang=js&"
export * from "./visitorRecord.vue?vue&type=script&lang=js&"
import style0 from "./visitorRecord.vue?vue&type=style&index=0&id=3d85c29a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports